import { createInstance } from './request';

const version = (_version) => ({
  'x-app-id': 'zP6WFH7WKz2vrw4Q',
  'x-version': _version,
});

const instance = createInstance({
  baseURL: process.env.NODE_ENV === 'development' ? '' : 'https://common-open-api.jin10.com',
  headers: version('1.0.0'),
});

export const getActivityDataById = (params) => instance.get('/configuration/getById', {
  params,
});

export const getComments = () => instance.get('https://cdn.jin10.com/activity/ttps/comments.json');

export const getStudents = () => instance.get('https://cdn.jin10.com/activity/ttps/students.json');
